import { AbstractDimension } from './abstract-dimension.ts'

export class StringsDimension<NAME extends string> extends AbstractDimension<NAME, string[]> {
  override formatToString(value: string[]): string {
    return value.join(', ')
  }
}
